module.exports = __webpack_public_path__ + "static/media/drag.09aac7f0.svg";